window.dbs = window.dbs || {}
dbs.utilities = dbs.utilities || {}

dbs.utilities.geolocation = function () {
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  const self = this
  self.events = new dbs.events()
  self.position = null

  self.init = function () {
    if (navigator.geolocation) {
      self.events.emit('Geolocation:supported', null, true)
    } else {
      self.events.emit('Geolocation:notSupported', null, true)
    }
  }

  self.handlePosition = function (position) {
    self.position = position
    self.events.emit('Geolocation:getPosition_response', self.position, true)
  }

  self.handleError = function (error) {
    self.events.emit('Geolocation:getPosition_error', error, true)
  }

  self.getPosition = function () {
    if (navigator.geolocation) {
      self.events.emit('Geolocation:getPosition', null, true)
      // See: https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition
      navigator.geolocation.getCurrentPosition(self.handlePosition, self.handleError, options);
    } else {
      self.events.emit('Geolocation:notSupported', null, true)
    }
  }
}
